import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";

@Component({
  selector: "sm-business-profile",
  templateUrl: "./business-profile.component.html",
  styleUrls: ["./business-profile.component.scss"],
})
export class BusinessProfileComponent implements OnInit {
  loader: boolean = false;
  apisub: Subscription
  _entityDetails: any= []
  constructor(
    private apiservice: ApiService,
    private navservice: NavigationService,
    private router: Router,
    private loaderservice: LoaderServiceService,
    private dialog:MatDialog,
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT){
        this._entityDetails = []
        if(resdata.result){
          this._entityDetails = resdata.result
          this._entityDetails.forEach((element:any) => {
            element.entity_services = typeof element.entity_services == 'string' ? JSON.parse(
              element.entity_services
            ) : element.entity_services;
            
            element.addressInfo = typeof element.addressInfo == 'string' ? JSON.parse(
              element.addressInfo
            ) : element.addressInfo;
            
  
            element.default_image = element.default_image && typeof element.default_image == 'string' ? JSON.parse(
              element.default_image
            ) : element.default_image;
            
          });
        }
        this.loaderservice.showLoader = false
        this.loader = false
      }
    })
  }

  ngOnInit(): void {
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBusinessList(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID));
  }
  createNewBusiness(){
    // this._modelRef.open(CreateNewBusinessComponent, {
    //   width: '500px',
    //   data: {
    //     title: 'Create Business',
    //     ref: this._modelRef
    //   },
    // });
    this.router.navigate(['purchased-plan']);
}
openBusinessDetails(item:any){
  localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_HASH, item.hashId);
  this.router.navigate(['/businesses','details'], {queryParams: {entityHash:item.hashId}})
}


openvideo(){
  this.dialog.open(YoutubeEmbedVideoComponent,{
  width:'1000px',
  disableClose:true,
  data:{
    link:"https://www.youtube.com/embed/yGNjTQ1wcGw",
    title: 'How to Add Business in LookzUp Web Portal? '
  }})
  }


  selectcountry(){
    this.loaderservice.showLoader = true
    let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
    maxWidth:'500px',
    width:'500px',
    disableClose:true,
    data:{
      link:"",
      title: 'Select country',
      ref: this.dialog
    }})
    dialogref.afterClosed().subscribe(res => {
      if(res){
        this.router.navigate(['purchased-plan']);
      }
    } 
    )
    }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }

  openLink(url: string): void {
    window.open(url, '_blank');
  }

}
